export const SET_NOTENEINGABE_STATI = 'setNotenEingabeStati'
export const SET_SICHTBARKEITEN = 'setSichtbarkeiten'
export const SET_NOTENEINGABE_TYPEN = 'setNotenEingabeTypen'
export const SET_NOTEN_TYPEN = 'setNotenTypen'
export const SET_TEXTWAHL_WERTE = 'setTextwahlWerte'
export const SET_NOTENSTRUKTUR_ABSCHLUESSE = 'setNotenstrukturAbschluesse'
export const SET_PROMOTION_STATI = 'setPromotionStati'
export const SET_FAECHER = 'setFaecher'
export const SET_ANSICHTSMODI = 'setAnsichtsmodi'
